import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from 'lucide-react'

const PrivacyPolicy = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const policy = t('privacypolicy', { returnObjects: true })
  const labels = policy.labels || {}

   const handleBackToDashboard = () => {
    // navigate('/dashboard')
    if (window.history.length > 2) {
      navigate(-1)
    } else {
      navigate('/dashboard')
    }
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Top Bar */}
      <div className="border-b border-gray-800">
        <div className="max-w-6xl mx-auto px-2 sm:px-4 lg:px-6 py-4">
          <button
            onClick={handleBackToDashboard}
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors duration-200"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-2 sm:px-4 lg:px-6 py-8 lg:py-12">
        <div className="mb-12">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-8 tracking-wide">
            {policy.title}
          </h1>
        </div>

        <div className="space-y-8 text-gray-200 text-sm sm:text-base leading-relaxed">
          {policy.sections?.map((section, idx) => (
            <div key={idx}>
              <h2 className="font-semibold text-lg mb-2">
                {idx + 1}. {section.heading}
              </h2>
              <p>{section.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
